/**
 * Stakeholders - people OUTSIDE the organisation who are connected to it:
 * investors, party members, constituents, media, donors.
 *
 * Deliberately not users. A stakeholder never signs in and holds no role:
 * this is a record ABOUT someone, not an account FOR them. Keeping the two
 * apart is what stops external contacts appearing in assignee pickers and
 * permission checks.
 *
 * Admin and Super Admin only - the whole module, read and write.
 */
export const StakeholderTag = {
    INVESTOR: 'INVESTOR',
    PARTY_MEMBER: 'PARTY_MEMBER',
    CONSTITUENT: 'CONSTITUENT',
    MEDIA: 'MEDIA',
    DONOR: 'DONOR',
};
export const STAKEHOLDER_TAG_LABEL = {
    INVESTOR: 'Investor',
    PARTY_MEMBER: 'Party member',
    CONSTITUENT: 'Constituent',
    MEDIA: 'Media',
    DONOR: 'Donor',
};
/** Fixed display order, so the chips never reshuffle between screens. */
export const STAKEHOLDER_TAG_ORDER = [
    'INVESTOR', 'PARTY_MEMBER', 'CONSTITUENT', 'MEDIA', 'DONOR',
];
/** How an interaction happened. DONATION is money, not a conversation -
 *  kept in the same log so the history reads in one timeline. */
export const InteractionKind = {
    CALL: 'CALL',
    MEETING: 'MEETING',
    EMAIL: 'EMAIL',
    MESSAGE: 'MESSAGE',
    EVENT: 'EVENT',
    DONATION: 'DONATION',
    OTHER: 'OTHER',
};
export const INTERACTION_KIND_LABEL = {
    CALL: 'Call',
    MEETING: 'Meeting',
    EMAIL: 'Email',
    MESSAGE: 'Message',
    EVENT: 'Event',
    DONATION: 'Donation',
    OTHER: 'Other',
};
export const STAKEHOLDER_NAME_MAX = 160;
export const STAKEHOLDER_NOTES_MAX = 20_000;
export const INTERACTION_SUMMARY_MAX = 500;
/** The default "gone quiet" threshold used by StakeholderStats. */
export const STAKEHOLDER_STALE_DAYS = 90;
//# sourceMappingURL=stakeholders.js.map